import { last } from 'fp-ts/lib/ReadonlyNonEmptyArray';
import { flow, pipe } from 'fp-ts/lib/function';
import { alt, map, getOrElse, fromPredicate } from 'fp-ts/lib/Option';
import { lookup } from 'fp-ts/lib/Record';
import { split, toUpperCase } from 'fp-ts/lib/string';
import { isServer } from './is-server';
import { match } from 'fp-ts/lib/boolean';

const countryLocaleMap = {
  sv: 'SE',
  da: 'DK',
  de: 'DE',
};

// RFC 5646 is en-US or en-us
const convertRFC5646 = flow(split('-'), last, toUpperCase);

const getBrowserLanguage = () =>
  pipe(
    isServer(),
    match(
      () => window.navigator.language,
      () => ''
    ),
    fromPredicate((lang) => !!lang),
    map(convertRFC5646)
  );

export const getDefaultCountry = (locale: string) =>
  pipe(
    countryLocaleMap,
    lookup(locale),
    alt(getBrowserLanguage),
    getOrElse(() => '')
  );
